"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _oxygenConfig = require("@8x8/oxygen-config");
var _StyledOverlay = _interopRequireDefault(require("../styled/StyledOverlay"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = (0, _oxygenConfig.withTheme)(_StyledOverlay["default"], 'overlay');
exports["default"] = _default;